import { render, staticRenderFns } from "./NewOccupationWizardButtons.vue?vue&type=template&id=31a59746&scoped=true&"
import script from "./NewOccupationWizardButtons.vue?vue&type=script&lang=js&"
export * from "./NewOccupationWizardButtons.vue?vue&type=script&lang=js&"
import style0 from "./NewOccupationWizardButtons.vue?vue&type=style&index=0&id=31a59746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a59746",
  null
  
)

export default component.exports